import activityPanelStyles from './activityPanelStyles';

const docPreviewFormStyle = (theme) => ({
  ...activityPanelStyles(theme),

  descriptionField: {
    marginTop: '0',
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: '100%',
  },
  downloadButton: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginLeft: '40px',
    marginTop: '12px',
  },
  assignmentDeadlineHolder: {
    marginLeft: '-14px',
  },
  hiddenAssignmentSelect: {
    visibility: 'hidden',
  },
  group: {
    margin: theme.spacing(0, 1),
  },
  datePickerDiv: {
    marginTop: '16px',
  },
  datePickerInput: {
    fontSize: '14px !important',
  },
  previewSize: {
    width: '500px',
    height: '400px',
  },
  buttonDiv: {
    float: 'right',
  },
});

export default docPreviewFormStyle;
